import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { SecAdminUserService } from '../services/sec-admin-user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  public constructor(private readonly secAdminUserService: SecAdminUserService) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    var currentUser = this.secAdminUserService.getCurrentUser();
    if (currentUser == null) {
      window.location.href = "/identity/account/login?returnUrl=" + state.url;
      return of(false);
    } else if (route.data.siteAdmin && currentUser.adminApplicationIds.length != 0) {
      return of(true)
    } else if (route.data.agencyAdmin && currentUser.adminAgencyIds.length !== 0) {
      return of(true);
    } else if (!route.data.agencyAdmin && !route.data.siteAdmin) {
      return of(true);
    }

    window.location.href = "/identity/account/accessdenied";
    return of(false);
  }
}
